import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearPendingAddToBag: CustomizationMachineAction = assign({
  shouldAddToBagWhenReady: false,
});
